import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Tab, Tabs, useTheme } from "@mui/material";
import { useState } from "react";

import PropTypes from "prop-types";
import { tokens } from "../../../../../../theme";
import { ContactsFileUploadSection } from "./ContactsFileUploadSection";

interface ImportContactsModalProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  fetchContacts: () => void;
  streamId: number | null;
}

type displayModeType = "select-data" | "confirm-data" | "key-mapping";
interface modalBoxPropertiesType {
  width: number | string;
  height: number | string;
  marginInline: string;
  marginTop: string;
  top: string;
  left: string;
  transform: string;
}

export const ImportContactsModal: React.FC<ImportContactsModalProps> = ({
  setOpen,
  fetchContacts,
  streamId,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [displayMode] = useState<displayModeType>("select-data");
  const [value, setValue] = useState(0);
  const [modalBoxProps, setModalBoxProps] = useState<modalBoxPropertiesType>({
    width: 500,
    height: "auto",
    marginInline: "inherit",
    marginTop: "inherit",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  });

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const changeTheWidthForVerifyData = (toDefault: boolean) => {
    if (toDefault) {
      setModalBoxProps({
        width: 500,
        height: "auto",
        marginInline: "inherit",
        marginTop: "inherit",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      });
      return;
    }
    setModalBoxProps({
      width: "80%",
      height: "90%",
      marginInline: "auto",
      marginTop: "3rem",
      top: "50%",
      left: "50%",
      transform: "translate(-60%,-55%)",
    });
  };

  return (
    <Modal
      open={true}
      aria-labelledby="import-contacts-modal"
      aria-describedby="import-contacts-modal-description"
    >
      <>
        {displayMode === "select-data" && (
          <Box
            sx={{
              borderRadius: "1.2rem",
              position: "relative",
              top: "50%",
              left: "50%",
              transform: modalBoxProps.transform,
              width: modalBoxProps.width,
              height: modalBoxProps.height,
              maxHeight: "90vh", // NEW — never exceed viewport
              overflowY: "auto", // NEW — scroll if content is taller
              marginInline: modalBoxProps.marginInline,
              marginTop: modalBoxProps.marginTop,
              bgcolor: colors.primary[900],
              boxShadow: 24,
              transition: ".2s ease-in-out",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 .5em",
                borderBottom: `1px solid whitesmoke`,
              }}
            >
              <Tabs value={value} onChange={handleChange}>
                <Tab label="File Upload" />
              </Tabs>

              <IconButton sx={{ "&:hover": { color: "#a60b0bff" } }}>
                <CloseIcon onClick={() => setOpen(false)} />
              </IconButton>
            </Box>

            <ContactsFileUploadSection
              setOpen={setOpen}
              fetchContacts={fetchContacts}
              changeModalProps={changeTheWidthForVerifyData}
              streamId={streamId}
            />
          </Box>
        )}
      </>
    </Modal>
  );
};

ImportContactsModal.propTypes = {
  setOpen: PropTypes.func.isRequired,
  fetchContacts: PropTypes.func.isRequired,
};
